export default __webpack_public_path__ + "static/media/logo.40c75b88.jpg";